import React from 'react';
import './Skeleton.css';

/**
 * Base Skeleton Component
 * Used as a building block for all skeleton loaders
 */
export const Skeleton = ({
  width = '100%',
  height = '20px',
  borderRadius = '4px',
  className = '',
  style = {},
  variant = 'rectangular' // rectangular, circular, text
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'circular':
        return { borderRadius: '50%', width: height }; // Make it a circle
      case 'text':
        return { borderRadius: '4px', height: '1em' };
      default:
        return {};
    }
  };

  return (
    <div
      className={`skeleton ${className}`}
      style={{
        width,
        height,
        borderRadius,
        ...getVariantStyles(),
        ...style
      }}
    />
  );
};

/**
 * Skeleton Text - for text placeholders
 */
export const SkeletonText = ({
  lines = 1,
  width = '100%',
  lastLineWidth = '80%',
  className = ''
}) => {
  return (
    <div className={className}>
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton
          key={index}
          width={index === lines - 1 ? lastLineWidth : width}
          height="1em"
          style={{ marginBottom: index < lines - 1 ? '0.5em' : 0 }}
        />
      ))}
    </div>
  );
};

/**
 * Skeleton Avatar - for profile pictures
 */
export const SkeletonAvatar = ({
  size = '40px',
  className = ''
}) => {
  return (
    <Skeleton
      variant="circular"
      height={size}
      className={className}
    />
  );
};

/**
 * Skeleton Card - for card layouts
 */
export const SkeletonCard = ({
  height = '200px',
  hasImage = false,
  imageHeight = '120px',
  children,
  className = ''
}) => {
  return (
    <div
      className={`skeleton-card ${className}`}
      style={{
        backgroundColor: 'var(--color-surface, #fff)',
        padding: '1.5rem',
        borderRadius: '0.75rem',
        border: '1px solid #e2e8f0',
        height
      }}
    >
      {hasImage && (
        <Skeleton
          height={imageHeight}
          style={{ marginBottom: '1rem' }}
        />
      )}
      {children || (
        <>
          <Skeleton
            width="60%"
            height="1.5rem"
            style={{ marginBottom: '1rem' }}
          />
          <SkeletonText lines={3} />
        </>
      )}
    </div>
  );
};

export default Skeleton;
